<template>
  <div class="feedback-meter" :class="{ clickable }">
    <Button class="feedback-button" :title="title" @click="onFeedbackClick(5)">
      <v-icon
        slot="icon-end"
        :name="checkAmount(5)"
        class="star-icon"
        :scale="scale"
      />
    </Button>

    <Button class="feedback-button" :title="title" @click="onFeedbackClick(4)">
      <v-icon
        slot="icon-end"
        :name="checkAmount(4)"
        class="star-icon"
        :scale="scale"
      />
    </Button>

    <Button class="feedback-button" :title="title" @click="onFeedbackClick(3)">
      <v-icon
        slot="icon-end"
        :name="checkAmount(3)"
        class="star-icon"
        :scale="scale"
      />
    </Button>

    <Button class="feedback-button" :title="title" @click="onFeedbackClick(2)">
      <v-icon
        slot="icon-end"
        :name="checkAmount(2)"
        class="star-icon"
        :scale="scale"
      />
    </Button>

    <Button class="feedback-button" :title="title" @click="onFeedbackClick(1)">
      <v-icon
        slot="icon-end"
        :name="checkAmount(1)"
        class="star-icon"
        :scale="scale"
      />
    </Button>
  </div>
</template>

<script>
import { getAccountId } from "@/lib/auth";

export default {
  name: "FeedbackMeter",

  props: {
    amount: {
      type: Number,
      default: 5,
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    outlines: {
      type: Boolean,
      default: false,
    },
    scale: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    title() {
      return this.clickable ? "How are we doing?" : "";
    },
  },
  methods: {
    checkAmount(item) {
      const outline = "regular/star";
      const filled = "star";

      // Return the outlines if the props been set
      if (this.outlines) return outline;

      // If the current item is equal to the passed in amount the return the filled icon. Otherwise return the outlined version.
      return item <= this.amount ? filled : outline;
    },
    onFeedbackClick(amount) {
      // NOTE: The row order is reveresed by the flex-direction property so the hover effect works. This has been accountted for in the amount argument markup above
      if (this.clickable) {
        this.$gtm.trackEvent({
          event: "promo-feedback-meter-click",
          value: amount,
          accountId: getAccountId(),
        });

        return this.$modal.show("review", {
          amount,
        });
      }

      return false;
    },
  },
};
</script>

<style scoped>
.feedback-meter {
  @apply flex justify-center;
  flex-direction: row-reverse;

  &.clickable {
    .feedback-button {
      cursor: pointer !important;

      &:hover,
      &:hover ~ .feedback-button {
        .star-icon {
          @apply text-brand;
          transform: scale(1.3);
        }
      }

      &:focus {
        .star-icon {
          @apply text-brand;
        }
      }
    }
  }
}

.feedback-button {
  @apply p-0 m-0 leading-none;
  cursor: default !important;

  &:focus {
    @apply outline-none;
  }
}

.star-icon {
  @apply mx-1 text-2xl;
  color: #ffcd43;
  transition: transform 300ms ease-out;
}
</style>
